import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { useOrientation } from '@hooks/useOrientation.tsx'
import './OrientationOverlay.scss'

export const OrientationOverlay: FunctionComponent = (): React.ReactElement | null => {
  const { t } = useTranslation('OrientationOverlay')

  const { isLandscape, isMobile } = useOrientation();

  if (!isLandscape || !isMobile) return null;


  return (
    <div className="OrientationOverlay">{t('message')}</div>
  );

}

export default OrientationOverlay
